import { t } from '@lingui/core/macro'

export enum Bank {
    alfabank = 'alfabank',
    tinkoff = 'tinkoff',
    pochtabank = 'pochtabank',
    raiffeisen = 'raiffeisen',
    sberbank = 'sberbank',
    vtb = 'vtb',
    uralsib = 'uralsib',
    gazprombank = 'gazprombank',
    rncbbank = 'rncbbank',
    solidarnost = 'solidarnost',
    asiaalliancebank = 'asiaalliancebank',
    garantbank = 'garantbank',
    octobank = 'octobank',
    poytaxtbank = 'poytaxtbank',
}

export interface BankName {
    bank: Bank
    name: string
}

export const getBankNames = () => [
    { bank: Bank.alfabank, name: t`Альфа-Банк` },
    { bank: Bank.tinkoff, name: t`Т-Банк` },
    { bank: Bank.pochtabank, name: t`Почта Банк` },
    { bank: Bank.raiffeisen, name: t`Райффайзен Банк` },
    { bank: Bank.sberbank, name: t`Сбербанк` },
    { bank: Bank.vtb, name: t`ВТБ` },
    { bank: Bank.uralsib, name: t`Уралсиб` },
    { bank: Bank.gazprombank, name: t`Газпромбанк` },
    { bank: Bank.rncbbank, name: t`РНКБ` },
    { bank: Bank.solidarnost, name: t`КБ Солидарность` },
    { bank: Bank.asiaalliancebank, name: 'Asia Alliance Bank' },
    { bank: Bank.garantbank, name: t`Гарант Банк` },
    { bank: Bank.octobank, name: 'Octobank' },
    { bank: Bank.poytaxtbank, name: t`Пойтахт Банк` },
] as BankName[]
